import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {StripeProvider} from 'react-stripe-elements';
import PetposCheckOut from './petposCheckOut';
import Config from '../../config';

class ViewPayment extends React.Component {
  constructor(props) {
      super(props);
    }

  render() {
    return (
    <StripeProvider apiKey={Config.stripeConfig.publisher_key}>
      <PetposCheckOut />
    </StripeProvider>
    )
  }
}

// const mapStateToProps = state => ({
// user: state.cognito.user,
// });

export default withRouter(connect()(ViewPayment));

